import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Input, Button } from "@nextui-org/react";
import Header from "../../reusable/Header";
import PoweredBy from "../../reusable/PoweredBy";

// Only Nigeria is supported today (see ProofOfResidency's hardcoded "NGA" on
// the core side) — a static dial-code chip instead of a functional country
// picker, matching CountrySelect.jsx/CountryLabel.jsx's flag-emoji convention.
const NIGERIA_FLAG = "🇳🇬";
const NIGERIA_DIAL_CODE = "234";

function PhoneNumberInput({ error, sendOtp, setPhoneInput }) {
    const { t } = useTranslation();
    const [value, setValue] = useState("");
    const [touched, setTouched] = useState(false);

    const digits = value.replace(/\D/g, "").replace(/^0+/, "");
    const isValidPhone = digits.length >= 10;
    const isInvalid = touched && !isValidPhone;

    const handleChange = (val) => {
        const nextDigits = val.replace(/\D/g, "").replace(/^0+/, "");
        setValue(val);
        setPhoneInput("+" + NIGERIA_DIAL_CODE + nextDigits);
    };

    const handleSubmit = () => {
        setTouched(true);
        if (isValidPhone) sendOtp();
    };

    return (
        <div className="flex h-full flex-col">
            <Header />
            <div className="flex flex-col p-5 h-full justify-between">

                <div className="flex flex-col gap-6">
                    <div className="flex flex-col items-center text-center gap-1">
                        <div className="heading text-xl">{t("phoneCheck.input.heading")}</div>
                        <div className="desc text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("phoneCheck.input.description")}</div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Input
                            type="tel"
                            placeholder={t("phoneCheck.input.placeholder")}
                            variant="bordered"
                            color="primary"
                            radius="sm"
                            size="lg"
                            startContent={
                                <div className="flex items-center gap-1 pr-2 mr-1 border-r border-default-200">
                                    <span className="text-xl leading-none">{NIGERIA_FLAG}</span>
                                    <span className="text-black">+{NIGERIA_DIAL_CODE}</span>
                                </div>
                            }
                            value={value}
                            onValueChange={handleChange}
                            onBlur={() => setTouched(true)}
                            isInvalid={isInvalid}
                            errorMessage={isInvalid ? t("phoneCheck.input.invalidPhone") : ""}
                        />
                        {error && (
                            <div className="text-red-500 text-sm text-center">{error}</div>
                        )}
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <Button
                        color="primary"
                        radius="sm"
                        size="lg"
                        fullWidth
                        isDisabled={!isValidPhone}
                        onClick={handleSubmit}
                    >
                        {t("phoneCheck.input.submitButton")}
                    </Button>
                    <div className="flex justify-center">
                        <PoweredBy />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default PhoneNumberInput;
